/* import __COLOCATED_TEMPLATE__ from './workflow-status-pill.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { stateName } from 'embercom/helpers/state-name';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    state: number;
    objectType: number;
    matchBehavior?: number;
  };
  Element: HTMLElement;
}

export default class WorkflowStatusPill extends Component<Signature> {
  @service declare intl: IntlService;

  get isLive() {
    return stateName([], this.args) === 'Live';
  }

  get stampConfig() {
    let config = {
      color: 'gray' as const,
      text: '',
    };

    if (this.isLive) {
      config.text = this.intl.t('standalone.common.workflow-status-pill.enabled');
    } else {
      config.text = this.intl.t('standalone.common.workflow-status-pill.disabled');
    }

    return config;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::WorkflowStatusPill': typeof WorkflowStatusPill;
  }
}
